import { motion } from 'framer-motion';
import { useState } from 'react';
import { PreviewSection } from './PreviewSection';

// Animation variants
const staggerChildren = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

export function CVGenerator() {
  const [file, setFile] = useState<File | null>(null);

  const handleFileSelected = (selectedFile: File) => {
    setFile(selectedFile);
  };

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        <motion.div 
          className="space-y-8"
          variants={staggerChildren}
          initial="hidden"
          animate="visible"
        >
          <motion.div variants={fadeIn}>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 tracking-tight">
              Get a tailored CV for a{' '}
              <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">
                Software Developer
              </span>{' '}
              role
            </h1>
            
            <p className="text-gray-600 text-lg leading-relaxed">
              Upload your current CV, select the job you're interested in, and opt to add additional information. We'll process your request and generate a custom CV for you.
            </p>
          </motion.div>

          <motion.div variants={fadeIn}>
            <div className="relative">
              <input
                type="text"
                placeholder="Enter your desired job title"
                className="w-full px-4 py-4 rounded-xl border border-gray-200 bg-white shadow-lg
                         focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all
                         text-lg"
              />
              <button 
                className="absolute right-2 top-2 bg-emerald-600 text-white px-6 py-2 rounded-lg
                         hover:bg-emerald-700 transition-all shadow-lg shadow-emerald-500/20
                         hover:shadow-emerald-500/30"
              >
                Create Resume
              </button>
            </div>
          </motion.div>
        </motion.div>
        
        <PreviewSection file={file} onFileSelected={handleFileSelected} />
      </div>
    </div>
  );
}